import { SystemIconDirectiveModule } from './../../../../shared/ui-components/atoms/icon-directive/icon.directive';
import { NgModule } from '@angular/core';
import { CreateOrderComponent } from './create-order.component';
import { SystemNewModalModule } from '../../../../shared/ui-components/molecules/newModal/new-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SystemButtonModule } from '@app/shared/ui-components';

@NgModule({
  declarations: [CreateOrderComponent],
  imports: [SystemNewModalModule, TranslateModule, SystemIconDirectiveModule, SystemButtonModule, CommonModule],
  exports: [CreateOrderComponent],
})
export class CreateOrderModalModule {}
